"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modules = void 0;
var tslib_1 = require("tslib");
var dependency_container_1 = (0, tslib_1.__importDefault)(require("./dependency-container"));
var root_container_1 = (0, tslib_1.__importDefault)(require("../modules/root-container/root-container"));
var event_emitter_1 = (0, tslib_1.__importDefault)(require("../modules/event-emitter/event-emitter"));
var playback_engine_1 = (0, tslib_1.__importDefault)(require("../modules/playback-engine/playback-engine"));
var theme_1 = (0, tslib_1.__importDefault)(require("../modules/ui/core/theme"));
var text_map_1 = (0, tslib_1.__importDefault)(require("../modules/text-map/text-map"));
var full_screen_manager_1 = (0, tslib_1.__importDefault)(require("../modules/full-screen-manager/full-screen-manager"));
var live_state_engine_1 = (0, tslib_1.__importDefault)(require("../modules/playback-engine/live-state-engine"));
var keyboard_control_1 = (0, tslib_1.__importDefault)(require("../modules/keyboard-control/keyboard-control"));
var debug_panel_1 = (0, tslib_1.__importDefault)(require("../modules/ui/debug-panel/debug-panel"));
var screen_1 = (0, tslib_1.__importDefault)(require("../modules/ui/screen/screen"));
var interaction_indicator_1 = (0, tslib_1.__importDefault)(require("../modules/ui/interaction-indicator/interaction-indicator"));
var overlay_1 = (0, tslib_1.__importDefault)(require("../modules/ui/overlay/overlay"));
var loader_1 = (0, tslib_1.__importDefault)(require("../modules/ui/loader/loader"));
var main_ui_block_1 = (0, tslib_1.__importDefault)(require("../modules/ui/main-ui-block/main-ui-block"));
var top_block_1 = (0, tslib_1.__importDefault)(require("../modules/ui/top-block/top-block"));
var title_1 = (0, tslib_1.__importDefault)(require("../modules/ui/title/title"));
var live_indicator_1 = (0, tslib_1.__importDefault)(require("../modules/ui/live-indicator/live-indicator"));
var bottom_block_1 = (0, tslib_1.__importDefault)(require("../modules/ui/bottom-block/bottom-block"));
var progress_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/progress/progress"));
var play_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/play/play"));
var time_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/time/time"));
var volume_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/volume/volume"));
var full_screen_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/full-screen/full-screen"));
var picture_in_picture_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/picture-in-picture/picture-in-picture"));
var logo_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/logo/logo"));
var download_1 = (0, tslib_1.__importDefault)(require("../modules/ui/controls/download/download"));
var picture_in_picture_2 = (0, tslib_1.__importDefault)(require("../modules/picture-in-picture/picture-in-picture"));
var preview_service_1 = (0, tslib_1.__importDefault)(require("../modules/ui/preview-service/preview-service"));
var preview_thumbnail_1 = (0, tslib_1.__importDefault)(require("../modules/ui/preview-thumbnail/preview-thumbnail"));
var preview_full_size_1 = (0, tslib_1.__importDefault)(require("../modules/ui/preview-full-size/preview-full-size"));
var tooltip_1 = require("../modules/ui/core/tooltip");
var html5video_output_1 = (0, tslib_1.__importDefault)(require("../modules/playback-engine/output/native/html5video-output"));
var asClass = dependency_container_1.default.asClass;
exports.modules = {
    RootContainer: root_container_1.default,
    EventEmitter: event_emitter_1.default,
    Engine: playback_engine_1.default,
    ThemeService: theme_1.default,
    TextMap: text_map_1.default,
    NativeOutput: html5video_output_1.default,
    FullScreenManager: full_screen_manager_1.default,
    PictureInPictureManager: picture_in_picture_2.default,
    LiveStateEngine: live_state_engine_1.default,
    KeyboardControls: keyboard_control_1.default,
    DebugPanel: debug_panel_1.default,
    Screen: screen_1.default,
    InteractionIndicator: interaction_indicator_1.default,
    Overlay: overlay_1.default,
    Loader: loader_1.default,
    MainUIBlock: main_ui_block_1.default,
    TopBlock: top_block_1.default,
    LiveIndicator: live_indicator_1.default,
    Title: title_1.default,
    BottomBlock: bottom_block_1.default,
    ProgressControl: progress_1.default,
    PlayControl: play_1.default,
    TimeControl: time_1.default,
    VolumeControl: volume_1.default,
    FullScreenControl: full_screen_1.default,
    PictureInPictureControl: picture_in_picture_1.default,
    Logo: logo_1.default,
    DownloadButton: download_1.default,
    PreviewService: preview_service_1.default,
    PreviewThumbnail: preview_thumbnail_1.default,
    PreviewFullSize: preview_full_size_1.default,
    TooltipService: tooltip_1.TooltipService,
};
var DIModules = Object.keys(exports.modules).reduce(function (processedModules, key) {
    var module = exports.modules[key];
    if (!module.moduleName) {
        throw new Error("No moduleName in module: ".concat(key));
    }
    processedModules[module.moduleName] = asClass(module).scoped();
    return processedModules;
}, {});
exports.default = DIModules;
//# sourceMappingURL=default-modules.js.map